import { Component } from '@angular/core';
import { Title,Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-uiux',
  templateUrl: './uiux.component.html',
  styleUrls: ['./uiux.component.css']
})
export class UIUXComponent {
  constructor(private titleServvice:Title,private metaService: Meta){}

  ngOnInit(): void {
    this.titleServvice.setTitle('Professional UI/UX Designing Services in Hyderabad | Call  7075451542')
    this.metaService.addTags([
      { name: 'description', content: 'Transform your digital presence with professional UI/UX designing services in Hyderabad. We deliver custom, user-focused designs for websites and mobile applications.' },
      { name: 'keywords', content: 'Professional UI/UX Designing Services in Hyderabad' }
    ]);
  }
}
